import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CookieService {
	constructor(
		@Inject(DOCUMENT) private readonly document: Document
	) { }

	set(
		name: string,
		value: string,
		days: number = 7,
		path: string = '/',
		domain?: string,
		secure: boolean = false,
		sameSite: 'Lax' | 'Strict' | 'None' = 'Lax'
	): void {
		let cookieString = `${name}=${encodeURIComponent(value)}`;

		if (days) {
			const expires = new Date(Date.now() + days * 864e5).toUTCString();
			cookieString += `; expires=${expires}`;
		}

		cookieString += `; path=${path}`;

		if (domain) cookieString += `; domain=${domain}`;
		if (secure) cookieString += `; secure`;
		if (sameSite) cookieString += `; samesite=${sameSite}`;

		this.document.cookie = cookieString;
	}

	get(name: string): string | null {
		let cookeString = this.document.cookie
				?.split('; ')
				.find((row) => row.startsWith(name + '='))
				?.split('=')[1] ?? null
		return (
			cookeString ? decodeURIComponent(cookeString) : null
		);
	}

	delete(name: string, path: string = '/', domain?: string): void {
		this.set(name, '', -1, path, domain);
	}

	deleteAll(path: string = '/', domain?: string): void {
		const cookies = this.document.cookie ? this.document.cookie.split(';') : [];
		for (const cookie of cookies) {
			const eqPos = cookie.indexOf('=');
			const cookieName =
				eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
			if (cookieName) {
				this.delete(cookieName, path, domain);
			}
		}
	}
}
